<template>
  <div class="elencocostruttoriadd">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Registra un costruttore</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12" md="12">
          <b-form-input class="slide-up" id="denominazione" v-model="formData.costruttore.denominazione" type="text" :state="state.denominazione" placeholder="Denominazione del costruttore" /><label for="denominazione">* Denominazione</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cf" v-model="formData.costruttore.cf" type="text" :state="state.cf" placeholder="Codice fiscale del costruttore" /><label for="cf">Codice Fiscale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="piva" v-model="formData.costruttore.piva" type="text" :state="state.piva" placeholder="Partita IVA del costruttore" /><label for="piva">Partita IVA</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>REFERENTE</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont1" v-model="formData.costruttore.cont1" type="text" :state="state.cont1" placeholder="Contatto principale del costruttore" /><label for="cont1">Principale</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cont2" v-model="formData.costruttore.cont2" type="text" :state="state.cont2" placeholder="Contatto secondario del costruttore" /><label for="cont2">Secondario</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>SEDE OPERATIVA</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <mappa
            v-bind:via.sync="formData.costruttore.via"
            v-bind:civico.sync="formData.costruttore.civico"
            v-bind:comune.sync="formData.costruttore.comune"
            v-bind:cap.sync="formData.costruttore.cap"
            v-bind:provincia.sync="formData.costruttore.provincia"
            v-bind:nazione.sync="formData.costruttore.nazione"
            v-bind:mappa.sync="flag.maps"
            :stato="state"
            ></mappa>
        </b-col>
      </b-row>
      <!-- INDIRIZZO INPUT -->
       <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="via" v-model="formData.costruttore.via" type="text" :state="state.via" placeholder="Via" /><label for="via">Via *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="civico" v-model="formData.costruttore.civico" type="text" :state="state.civico" placeholder="Civico" /><label for="civico">Civico *</label>
          <br>
          <br>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="comune" v-model="formData.costruttore.comune" type="text" :state="state.comune" placeholder="Comune" /><label for="comune">Comune *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="cap" v-model="formData.costruttore.cap" type="text" :state="state.cap" placeholder="CAP" /><label for="cap">CAP *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="provincia" v-model="formData.costruttore.provincia" type="text" :state="state.provincia" placeholder="Provincia" /><label for="provincia">Provincia *</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="nazione" v-model="formData.costruttore.nazione" type="text" :state="state.nazione" placeholder="Nazione" /><label for="nazione">Nazione *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <!-- /INDIRIZZO INPUT -->
      <b-row class="separatore_text">
        <b-col>
          <hr>
        </b-col>
        <b-col>
          <h5>ALTRE INFORMAZIONI</h5>
        </b-col>
        <b-col>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="website" v-model="formData.costruttore.website" type="text" :state="state.website" placeholder="Sito web del costruttore" /><label for="website">Sito web</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-input class="slide-up" id="email" v-model="formData.costruttore.email" type="text" :state="state.email" placeholder="Email del costruttore" /><label for="email">Email</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="cellulare" v-model="formData.costruttore.cellulare" type="text" :state="state.cellulare" placeholder="Numero di cellulare del costruttore" /><label for="cellulare">Cellulare</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="telefono" v-model="formData.costruttore.telefono" type="text" :state="state.telefono" placeholder="Numero del telefono fisso del costruttore" /><label for="telefono">Telefono fisso</label>
          <br>
          <br>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-input class="slide-up" id="fax" v-model="formData.costruttore.fax" type="text" :state="state.fax" placeholder="Numero del Fax del costruttore" /><label for="fax">Fax</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.costruttore.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <b-row v-if="stato.admin">
        <b-col>
          <b-form-checkbox v-model="formData.costruttore.globale" :value="true" :unchecked-value="false">Rendi il costruttore globale</b-form-checkbox>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="addCostruttore()"><font-awesome-icon icon="plus-circle" /> Crea</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import Mappa from '@/components/component/advance/mappa.vue'
import { mapGetters } from 'vuex'
import { globalConf } from '../../../config.global'

var map

export default {
  name: 'elencocostruttoriadd',
  components: {
    Mappa
  },
  data() {
    return {
      state: {
        idTipocliente: null,
        denominazione: null,
        cf: null,
        piva: null,
        cont1: null,
        cont2: null,
        website: null,
        email: null,
        cellulare: null,
        telefono: null,
        fax: null,
        note: null,
        via: null,
        civico: null,
        nazione: null,
        provincia: null,
        comune: null,
        cap: null,
        search_address: null
      },
      formData:{
        costruttore: {
          denominazione: '',
          cf: '',
          piva: '',
          cont1: '',
          cont2: '',
          via: '',
          civico: '',
          nazione: '',
          provincia: '',
          comune: '',
          cap: '',
          website: '',
          email: '',
          cellulare: '',
          telefono: '',
          fax: '',
          note: '',
          globale: false
        }
      },
      flag:{
        maps: true
      }
    }
  },
  methods: {
    addCostruttore(){
      var req = JSON.parse(JSON.stringify(this.formData))
      req.costruttore.ind_mappa = this.flag.maps
      Vue.http.post('elenco/costruttori/add', req, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Costruttore aggiunto con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/costruttori')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la registrazione',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#denominazione{
  text-indent: 155px;
}

#cf{
  text-indent: 140px;
}

#piva{
  text-indent: 110px;
}

#website{
  text-indent: 95px;
}

#cellulare{
  text-indent: 95px;
}

#telefono{
  text-indent: 130px;
}

#fax{
  text-indent: 60px;
}

#note{
  text-indent: 70px;
  line-height: 1.8;
}

#email{
  text-indent: 85px;
}

#cont1{
  text-indent: 105px;
}

#cont2{
  text-indent: 110px;
}

#via {
  text-indent: 65px;
}
#civico {
  text-indent: 80px;
}
#comune {
  text-indent: 100px;
}
#cap {
  text-indent: 70px;
}
#provincia {
  text-indent: 105px;
}
#nazione {
  text-indent: 95px;
}
</style>